import React from "react";
import styled from "styled-components";

export default styled.div`
    cursor: pointer;
    width: 50%;
    float: left;
    text-align: center;
    border-bottom: 1px solid gray;
    font-size: 16px;
    line-height: 19px;
    padding-bottom: 20px;
    ${(props) =>
    props.open
        ? {
        "border-bottom": "5px solid #3BBCB6",
        "padding-bottom": "16px",
        "color": "#5562C0",
        "font-weight": "700",
    }
        : ""}
    ${(props) =>
    props.fullwidth
        ? {
        "width": "100% !important",
    }
        : ""}
    ${(props) =>
    props.hidden
        ? {
        "display": "none",
    }
        : ""}
`;